@if (
  can(RoleAction.Read, RolePermissionSubject.Shift) &&
  ('portal-export-shift' | featureFlagPure | async)
) {
  <li (click)="exportShift()" nz-menu-item>
    {{ 'page.shift_details.export_shift' | translate }}
  </li>
}
